import * as React from "react";
import type { SVGProps } from "react";
const SvgHomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    viewBox="-5 -10 94.112 88.379"
    {...props}
  >
    <path d="M88.025 26.231 43.908-9.347a2.94 2.94 0 0 0-3.695 0L-3.904 26.231a2.94 2.94 0 0 0-.442 4.137 2.945 2.945 0 0 0 4.137.441l6.129-4.941v49.57a2.94 2.94 0 0 0 2.941 2.941h65.117a2.94 2.94 0 0 0 2.942-2.941V24.833l7.41 5.977a2.92 2.92 0 0 0 1.848.652c2.707.043 4.011-3.531 1.847-5.23Zm-27.21 18.04c-1.224 4.218-4.583 8.452-9.958 12.546-3.836 2.922-7.324 4.696-7.469 4.77a2.924 2.924 0 0 1-2.648 0c-.149-.078-3.637-1.848-7.469-4.77-5.375-4.093-8.734-8.328-9.969-12.602-2.054-6.582-.453-13.457 3.907-16.672.054-.035.105-.078.164-.113 5.746-3.652 11.293-1.512 14.695 1.094 3.398-2.606 8.945-4.746 14.695-1.094.058.035.113.078.164.113 4.36 3.211 5.957 10.09 3.894 16.723Z" />
    <path
      d="M267.557 14.335q-6.874-6.876-16.559-6.876h-78.127q-9.683 0-16.561 6.876-6.876 6.878-6.876 16.561v78.126q0 9.685 6.876 16.561 6.878 6.878 16.561 6.878h78.126q9.685 0 16.56-6.878 6.877-6.877 6.877-16.56V30.895q0-9.684-6.877-16.561m-13.956 58.228q-.001 3.418-3.173 4.802-1.06.406-2.035.406-2.196 0-3.662-1.546l-11.719-11.719-43.456 43.458q-1.546 1.547-3.662 1.547-2.117 0-3.663-1.547l-8.3-8.301q-1.548-1.547-1.547-3.662 0-2.115 1.546-3.662l43.458-43.458-11.719-11.719q-2.522-2.358-1.14-5.696 1.385-3.175 4.802-3.175h39.062q2.115.001 3.663 1.547 1.545 1.546 1.545 3.662Z"
      style={{
        strokeWidth: 0.998873,
      }}
    />
  </svg>
);
export default SvgHomeIcon;
